import { ca } from '@cian/analytics';

export function trackPlacesShow(): void {
  ca('eventSite', {
    action: 'show_sopr_collections',
    category: 'Listing',
    label: 'OneTwoTrip',
    name: 'oldevent',
  });
}

export function trackPlaceClick(label: string): void {
  ca('eventSite', {
    action: 'click_collections',
    category: 'Listing',
    label,
    name: 'oldevent',
  });
}
